import React, { useState } from "react"
import styled, { keyframes, css } from "styled-components"
import { media } from "../../components/mediaStyles"
import { colors } from "../../components/Color"
import Text from "../../components/Text/Text"
import CheckIcon from "../../Form/Question/types/CheckIcon"

const clickAnimation = keyframes`
  0% {
    box-shadow: 0 2px 4x 0 rgba(0, 0, 0, 0.3);
  }
  
  50% {
    box-shadow: 0 1px 0px 0 rgba(0, 0, 0, 0.3);
  }
  
  100% {
    box-shadow: 0 2px 4x 0 rgba(0, 0, 0, 0.3);
  }
`

const Tile = styled.div`
  position: relative;
  font-family: GT America, sans-serif;
  width: 100%;
  min-height: 40px;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
  max-width: 100%;
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: center;
  padding: 13px;
  font-weight: 500;
  font-size: 14px;
  border: 1px solid transparent;

  ${props => {
    if (props.selected) {
      return css`
        animation: ${clickAnimation} 0.4s ease-out;
      `
    }
  }}

  ${media.tablet`
    min-height: 80px;
    padding: 20px;
    width: 100%;
    
    &:hover {
      // color: ${colors.tertiary};
      // background: ${colors.teal};
      // border: 1px solid ${colors.teal};
      box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
      cursor: pointer;
    }
    `}

      &:active {
    // border: 1px solid ${colors.teal};
    // color: ${colors.tertiary};
    // background: ${colors.teal};
    cursor: pointer;
  }

  ${props =>
    props.disabled &&
    css`
      opacity: 0.6;
      &:hover,
      :active {
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
        cursor: not-allowed;
      }
    `}
`

const Checked = styled.div`
  display: flex;
  justify-content: flex-end;
  position: absolute;
  bottom: 10px;
  right: 10px;
`

export default ({
  name,
  description,
  onClick = () => {},
  disabled,
  checked,
}) => {
  const [selected, setSelected] = useState(false)

  const onSelect = event => {
    if (disabled) return
    setSelected(true)
    setTimeout(() => {
      setSelected(false)
      onClick(event)
    }, 400)
  }

  return (
    <Tile selected={selected} onClick={onSelect} disabled={disabled}>
      <Text size="medium">{name}</Text>
      <Text size="small">{description}</Text>
      {checked && (
        <Checked>
          <CheckIcon />
        </Checked>
      )}
    </Tile>
  )
}
